import { useEffect, useState } from 'react';
import { addNotification } from '../../../supplementary_components/store';
import { FuelCardStatusToggle } from './FuelCardStatusToggle';
import { useFuelCardListToggle } from './fuelCardListToggleContext';
import {
    isFuelCardStatusToggleable,
    requestFuelCardStatusChange,
} from './fuelCardStatusToggleUtils';
import styles from './fuelCardStatusToggle.module.scss';

function applyFuelCardListUpdate(payload, setData, setFilteredData) {
    if (!payload?.id) {
        return;
    }
    setData((prev) => (prev ?? []).map((item) => (item.id === payload.id ? payload : item)));
    setFilteredData((prev) => {
        if (!prev?.dataset) {
            return prev;
        }
        return {
            ...prev,
            dataset: prev.dataset.map((item) => (item.id === payload.id ? payload : item)),
        };
    });
}

export function FuelCardListStatusCell({ fuelCard, setData, setFilteredData }) {
    const listToggle = useFuelCardListToggle();
    const status = fuelCard?.status;
    // const displayStatus = formatFuelCardStatusLabel(status);
    const canToggle = isFuelCardStatusToggleable(status);
    const [isActive, setIsActive] = useState(() => status === 'ACTIVE');

    useEffect(() => {
        setIsActive(status === 'ACTIVE');
    }, [status]);

    const pendingCardId = listToggle?.pendingCardId ?? null;
    const isThisLoading = pendingCardId === fuelCard?.id;
    const isGloballyDisabled = listToggle?.isGloballyDisabled ?? false;
    const toggleDisabled = isGloballyDisabled && !isThisLoading;

    const handleToggleChange = () => {
        if (!canToggle || isGloballyDisabled || !fuelCard?.id) {
            return;
        }
        const desiredStatus = isActive ? 'INACTIVE' : 'ACTIVE';
        listToggle?.beginToggle(fuelCard.id);

        requestFuelCardStatusChange({
            fuelCardId: fuelCard.id,
            desiredStatus,
            truckId: fuelCard.currentTruck?.id,
            onSuccess: (payload) => {
                if (payload && Object.keys(payload).length > 0) {
                    setIsActive(payload.status === 'ACTIVE');
                    applyFuelCardListUpdate(payload, setData, setFilteredData);
                }
                listToggle?.endToggle();
            },
            onError: () => {
                addNotification({ message: 'Failed to update fuel card status', type: 'alert' });
                listToggle?.endToggle();
            },
        });
    };

    return (
        <div
            className={styles.listStatusCell}
            onClick={(e) => e.stopPropagation()}
            data-row-toggle="ignore"
        >
            {/* <span className={styles.listStatusLabel}>{displayStatus}</span> */}
            {canToggle ? (
                <FuelCardStatusToggle
                    isActive={isActive}
                    loading={isThisLoading}
                    disabled={toggleDisabled}
                    onToggle={handleToggleChange}
                />
            ) : null}
        </div>
    );
}
